import { RewardId } from '@/enums/reward-id';
import { RewardNotification } from '@/models/notification/notification';
import { RewardExtraParams } from '@/models/notification/notificationExtraParams';
import { UserRewardStatusId } from '@/models/user-reward/status/id';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import useTranslation from 'next-translate/useTranslation';
import { BaseContent } from '..';
import NotificationCoin from '../../Coin';
import { NotificationContentProps } from '../props';

export default function RewardNotificationContent({
  notification,
  type,
}: NotificationContentProps<RewardNotification>) {
  const { t } = useTranslation('notify');
  const extra: RewardExtraParams = notification.extra;

  return (
    <BaseContent
      icon="fa-solid fa-trophy-star"
      title={t('reward_title_available', {
        reward_name: t(`bonus:${extra.reward?.id}_reward_name`),
        reward_conclusion: t(`reward_conclusion_${extra.reward?.statusId}`),
      })}
      description={t(
        extra?.reward?.id?.toString() === RewardId.LuckyWheel.toString()
          ? 'reward_description'
          : 'reward_description_available',
        {
          reward_name: t(`bonus:${extra.reward?.id}_reward_name`),
          status: t(`status_${UserRewardStatusId.Available}`),
          reward_conclusion: t(`reward_conclusion_${extra.reward?.statusId}`),
          amount: WalletService.maskCurrency({
            amount: getMoneyOrAmount(extra?.amount),
            coin: extra?.coin,
            hideSymbol: true,
          }),
        },
      )}
      components={{
        coin: <NotificationCoin coin={extra?.coin} />,
      }}
      type={type}
      createdAt={notification?.createdAt ?? ''}
      notificationTypeId={notification?.type?.id}
      //@ts-ignore
      extra={notification?.extra}
    />
  );
}
